// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".error-info-container p[data-v-5152a7c0]{margin:0 0 10px}.error-info-container h1[data-v-5152a7c0]{font-weight:400;font-size:26px;color:#4d148c;padding:0;margin:20px 0 20px 0;line-height:45px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
